import React from 'react'
import PanelMain from '../components/panel-testing/PanelMain'
import PanelTests from '../components/panel-testing/PanelTests'
import PanelServices from '../components/panel-testing/PanelServices'
import PanelCommitment from '../components/panel-testing/PanelCommitment'
import PanelReliableCustomerService from '../components/panel-testing/PanelReliableCustomerService'
import PanelContactUs from '../components/panel-testing/PanelContactUs'
import MainHeader from '../layout/MainHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'

const PanelTestingPage = () => {
  
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>

    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Laboratory Testing Services in Chicago | RSV, Influenza, Respiratory Panel Test Services</title>
      <meta name="description" content="United Lab Care provides Covid-19, Influenza, RSV, and Respiratory Pathogen Panel testing services in Chicago land area." />
	<link rel="canonical" href="https://unitedlabcare.com/services/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Laboratory Testing Services in Chicago | RSV, Influenza, Respiratory Panel Test Services" />
	<meta property="og:description" content="United Lab Care provides Covid-19, Influenza, RSV, and Respiratory Pathogen Panel testing services in Chicago land area." />
	<meta property="og:url" content="https://unitedlabcare.com/services/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-03-29T12:20:45+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/01/United-Lab-Care-Logo-social-share.jpg" />
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />
	<meta property="og:image:type" content="image/jpeg" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="3 minutes" />
      </Helmet>
    </HelmetProvider>
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <PanelMain/>
        <PanelTests/>
        <PanelServices/>
        <PanelCommitment/>
        <PanelReliableCustomerService/>
        <PanelContactUs/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default PanelTestingPage